var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"log",attrs:{"pa2":""}},_vm._l((_vm.log),function(item,index){return _c('item',{key:index,attrs:{"item":item,"side":_vm.side(item)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }